import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, MapPin, Clock, Phone, Mail } from 'lucide-react';
import { ZipCodeValidator } from '../components/ZipCodeValidator';

export function ShippingInformation() {
  const [isLocationValid, setIsLocationValid] = React.useState(false);

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <Link 
            to="/"
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-8"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Home
          </Link>

          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="p-6 sm:p-8">
              <div className="flex items-center mb-8">
                <MapPin className="w-8 h-8 text-blue-600 mr-3" />
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
                  Shipping Information
                </h1>
              </div>

              <div className="space-y-8">
                {/* Service Area Check */}
                <div>
                  <h2 className="text-xl font-semibold text-gray-900 mb-4">
                    Check Your Location
                  </h2>
                  <ZipCodeValidator onValidation={setIsLocationValid} />
                </div>

                {/* Delivery Zone Map */}
                <div>
                  <h2 className="text-xl font-semibold text-gray-900 mb-4">
                    Delivery Zone
                  </h2>
                  <div className="rounded-lg overflow-hidden shadow-md">
                    <img
                      src="/Screenshot 2025-04-30 172150.jpg"
                      alt="Delivery Zone Map"
                      className="w-full h-auto object-contain max-w-full"
                      loading="lazy"
                    />
                  </div>
                  <p className="mt-2 text-sm text-gray-600 text-center">
                    We only deliver within the red-lined boundary shown above.
                  </p>
                </div>

                {/* Shipping Policy */}
                <div className="bg-blue-50 rounded-lg p-6">
                  <h2 className="text-lg font-semibold text-blue-900 mb-4">
                    Shipping Policy
                  </h2>
                  <div className="space-y-4 text-blue-800">
                    <p>
                      We provide delivery and installation services within our designated service area, 
                      which includes parts of Los Angeles, Orange, San Bernardino, and Riverside counties. 
                      Please use our address checker above to verify if your location is within our delivery zone.
                    </p>
                    <div className="flex items-start space-x-2">
                      <MapPin className="w-5 h-5 text-blue-600 mt-1 flex-shrink-0" />
                      <p>
                        Service Center Location:<br />
                        126 W 5th St<br />
                        Santa Ana, CA 92703
                      </p>
                    </div>
                  </div>
                </div>

                {/* Delivery Details */}
                <div className="grid gap-6 md:grid-cols-2">
                  <div className="bg-gray-50 rounded-lg p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">Delivery Hours</h3>
                    <div className="flex items-start space-x-3">
                      <Clock className="w-5 h-5 text-gray-600 mt-1" />
                      <div>
                        <p className="text-gray-600">Monday - Saturday</p>
                        <p className="text-gray-600">9:00 AM - 5:00 PM</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 rounded-lg p-6">
                    <h3 className="font-semibold text-gray-900 mb-4">Contact Information</h3>
                    <div className="space-y-3">
                      <div className="flex items-center space-x-2">
                        <Phone className="w-5 h-5 text-gray-600" />
                        <span className="text-gray-600">909‑990‑9090</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Mail className="w-5 h-5 text-gray-600" />
                        <span className="text-gray-600">vholicllc@gmail.com</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}